import type { Jast } from '@atlaskit/jql-ast';
import { substring } from './common.tsx';

export const getPrimarySortField = (jast: Jast) => {
	const primarySortField = jast.query?.orderBy?.fields[0];
	return primarySortField?.field.properties && primarySortField?.field?.position
		? substring(
				jast.represents,
				primarySortField?.field?.position[0],
				primarySortField?.field?.position[1],
			)
		: primarySortField?.field.value;
};
